export const ptBRSidebarTranslation = {
  sidebar: {
    home: 'Início',
    your_data: {
      title: 'Seus Dados',
      company_data: 'Dados da empresa',
      meritocracy_policies: 'Políticas de meritocracia',
      staff_data: 'Dados dos funcionários',
      grades: 'Grades',
      salary_grade: 'Tabela salarial',
      salary_scale_by_position: 'Tabela salarial por Cargo',
    },
    job_structure: {
      title: 'Estrutura de cargos',
      matrix_creation: 'Criação de matriz',
      matrix_view: 'Visualizar matriz',
      job_mapping: 'De-para cargo',
      job_description: 'Descrição de cargo',
    },
    remuneration_strategy: {
      title: 'Estratégia de remuneração',
      salary_tables: 'Tabelas salariais',
      framing_cost: 'Custo de enquadramento',
      market_data: 'Dados de mercado',
      competitiveness_analysis: 'Análise de competitividade',
      incentive_targets: 'Alvos de incentivo',
    },
    dashboard: {
      title: 'Dashboard de remuneração',
      employees: 'Funcionários',
      company: 'Empresa',
    },
    meritocracy: {
      title: 'Meritocracia',
      simulations: 'Simulações',
      parameters: 'Parametrizações',
    },
    central_upload: {
      title: 'Central de Upload',
      upload: 'Upload',
      history: 'Histórico',
    },
    access_control: {
      title: 'Controle de Acesso',
    },
  },
};
